import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import RightBanners from "../components/rightbanners";
import SeoHeaders from "../components/seoheaders";
import Loading from "../components/loading";
import * as wConsts from "../consts/website-consts";
class About extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "blog" });

  }

  render() {
    let showBan = this.props.WebPage.Settings.ShowRightBanners;
    if(!this.props.WebPage.PageLoaded) {
      return (
        <Loading/>
      );
    }



    return (
      <div className="content-wrap">
        <SeoHeaders Position={"Top"}/>

        <div className={`cell ${showBan ? "x9" : "x12"}`}>
          <div className="white-wrap the-content">

          </div>
        </div>
        {showBan &&
        <div className="cell x3">
          <RightBanners/>
        </div>
        }
        <SeoHeaders Position={"Bottom"}/>

      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website,
  };
}

export default connect(mapStateToProps)(About);
